module.exports = __webpack_public_path__ + "static/media/frontendIcon.a6f17998.svg";